<div class="access-denied-container bg-color">
  <div class="card">
    <h1 class="error-code">403</h1>
    <h2 class="title">Forbidden</h2>
    <p class="message">Access to this resource on the server is denied!</p>
    <button class="back-btn" (click)="goBack()">Go Back</button>
  </div>
</div>